import api from '../_api'

const getSRconfigsByLevel = ({ commit, rootState }) => {
  return new Promise((resolve, reject) => {
    commit('SR_CONFIGS_LEVEL_LOADING')
    api.fetchSrConfigsByLevel(rootState.user.levelId)
      .then((response) => {
        if (response.success) {
          commit('SR_CONFIGS_LEVEL_UPDATED', response.data.data)
          resolve({
            success: true,
            data: response.data
          })
        } else {
          commit('SR_CONFIGS_LEVEL_ERROR')
          resolve({
            success: response.success
          })
        }
      })
      .catch(() => {
        commit('SR_CONFIGS_LEVEL_ERROR')
        resolve({
          success: false
        })
      })
  })
}

const getSuccessRates = ({ commit, rootState }, { filters }) => {
  let { from, to } = filters
  // if(checkAgreementDate(from,rootState.user.agreementDate) === 'agreementDate'){
  //   from = from
  //   to = rootState.user.agreementDate
  //   commit('NO_MORE_SUCCESS_RATE')
  // }
  return new Promise((resolve, reject) => {
    commit('SUCCESS_RATE_LOADING')
    api.fetchSuccessRates(rootState.user.id, {
      date_from: from,
      date_to: to
    })
      .then((response) => {
        if (response.success) {
          if (response.data.length === 0) {
            commit('NO_MORE_SUCCESS_RATE')
            resolve({
              success: response.success
            })
          } else {
            commit('SUCCESS_RATE_UPDATED', response.data)
            resolve({
              success: true,
              data: response.data
            })
          }
        } else {
          commit('SUCCESS_RATE_ERROR')
          resolve({
            success: response.success
          })
        }
      })
      .catch((err) => {
        console.error(err)
        commit('SUCCESS_RATE_ERROR')
        resolve({
          success: false
        })
      })
  })
}

export default{
  getSRconfigsByLevel,
  getSuccessRates
}
